import React, { Component } from 'react'
import { Play } from './icons'
import FsLightbox from 'fslightbox-react'

class AgentVideos extends Component {

  state = {
    videoLightbox: false,
    currentVideo: null,
  }

  render() {

    let { title, videos } = this.props
    let { videoLightbox, currentVideo } = this.state

    return (
      <section className='profile__properties agent-videos'>
        <div className='profile__menu'>
          <ul>
            { title && 
              <li className='active'>
                {title}
              </li>
            }
          </ul>
        </div>
        <div className='profile__list'>
          <div className='profile__slider' ref={this.slider}>
            { videos?.length > 0 && videos.map((el, i) => {
              let videoSrc = ''
              if ( el.video.includes('.be/') ) {
                videoSrc = `https://www.youtube.com/embed/${el.video.split('.be/')[1]}?autoplay=1`
              } else if (el.video.includes('shorts')) {
                videoSrc = `https://www.youtube.com/embed/${el.video.split('shorts/')[1]}?autoplay=1`
              } else {
                videoSrc = `https://www.youtube.com/embed/${el.video.split('watch?v=')[1]}?autoplay=1`
              }
              return (
                <div className='video-card' key={i}>
                  <div className='video-card__image' onClick={() => this.setState({ videoLightbox: !videoLightbox, currentVideo: videoSrc })}>    
                    <img loading='lazy' src={el.image?.sourceUrl} alt={el.title} />
                    <span className='play'><Play color={'#FFFFFF'} /></span>
                  </div>
                  <div className='video-card__title' onClick={() => this.setState({ videoLightbox: !videoLightbox, currentVideo: videoSrc })}>
                    <h4 dangerouslySetInnerHTML={{ __html: el.title }} />
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        { currentVideo &&
          <FsLightbox
            toggler={videoLightbox}
            sources={[
              <iframe
                frameBorder="0"
                width="1920px"
                height="1080px"
                allow="autoplay; fullscreen"
                src={currentVideo}>
              </iframe>
            ]}
          />
        }
      </section>
    )
  }
}

export default AgentVideos